<template>
  <div>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ $t('formError.unknownwError') }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive
      :busy="isBusy"
      show-empty
      class="signature-list"
      thead-class="d-none"
      :borderless="true"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template v-slot:empty>
        <h4>Sie haben noch keine Person eingeladen</h4>
      </template>

      <template v-slot:cell(invitedDate)="row">
        <span>{{ row.item.invitedDate | moment("DD.MM.YYYY") }}</span>
      </template>

      <template v-slot:cell(inviteState)="row">
        <span v-if="row.item.inviteState === 'INVITED'">Eingeladen</span>
        <span v-else-if="row.item.inviteState === 'ACCEPTED'">Akzeptiert</span>
        <span v-else-if="row.item.inviteState === 'DENIED'">Abgelehnt</span>
        <span v-else></span>
      </template>
    </b-table>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      email: '',
      username: '',
      invitedDate: '',
      inviteState: '',
      hasUnknownError: false,
      hasError: false,
      errorMessage: '',
      isBusy: false,
      sortBy: 'invitedDate',
      sortDesc: true,
      fields: [
        { key: 'email', label: 'E-Mail', sortable: true },
        { key: 'invitedDate', label: 'Eingeladen am', sortable: true },
        { key: 'inviteState', label: 'Status', sortable: true }
        // { key: 'funktionen', label: '' }
      ]
    }),
    props: {
      applicationId: {
        type: Number,
        required: true
      }
    },
    created () {
      this.getPermissions()
    },
    methods: {
      async getPermissions () {
        this.isBusy = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('permission/GET_PERMISSIONS_SIGNATURE', this.applicationId).then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            this.isBusy = false
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      }
    },
    computed: {
      ...mapGetters({ items: 'permission/PERMISSIONS_SIGNATURE' })
    },
    watch: {
      applicationId (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getPermissions()
        }
      }
    }
  }
</script>

<style lang="scss">
  .search-col{
    padding-left: 0;
    padding-right: 0;
  }
  .table-btns{
    margin-bottom: 0;
    a {
     line-height: 1;
   }
  }
  .icon-delete, .icon-edit{
    cursor: pointer;
  }

  .signature-list.table-responsive {
    .table td {
      padding: .25rem 0 0;
    }
  }
</style>
